import { Navigate, Route, Routes } from "react-router";

import { ProtectedRoute } from "@/components/protected-route";
import { MyCardPage } from "@/features/card";
import { ColleagueCardPage, ColleaguesPage } from "@/features/colleagues";
import { PrintExportPage } from "@/features/colleagues/print-export";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { TeamsAuthEndPage } from "@/features/teams-auth-end";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/teams-auth-end" element={<TeamsAuthEndPage />} />
      <Route element={<ProtectedRoute />}>
        {/* `/home` is where the backend's SSO callback lands, so the own card lives there. */}
        <Route path="/home" element={<MyCardPage />} />
        <Route path="/colleagues" element={<ColleaguesPage />} />
        <Route path="/colleagues/print" element={<PrintExportPage />} />
        <Route path="/colleagues/:id" element={<ColleagueCardPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
